import { createTheme } from '@mui/material/styles'

import palette from './palette'
import shadows from './shadows'
import fonts from './fonts'

export default createTheme({
  palette,
  shadows,
  typography: fonts,
})
